import { render, staticRenderFns } from "./wechatInsurance.vue?vue&type=template&id=1c1affe2&scoped=true&"
import script from "./wechatInsurance.vue?vue&type=script&lang=js&"
export * from "./wechatInsurance.vue?vue&type=script&lang=js&"
import style0 from "./wechatInsurance.vue?vue&type=style&index=0&id=1c1affe2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1affe2",
  null
  
)

export default component.exports